<div class="card mt-3">
  <div class="card-body">
    <h3 class="mb-4">{{ 'MENU.DASHBOARD.edit_faq' | translate }}</h3>

    <form (ngSubmit)="updateProduct()" enctype="multipart/form-data">
<div class="row">
  <!-- Question -->
<div class="col-sm-6">
  <div class="mb-3">
    <label class="form-label">{{ 'MENU.DASHBOARD.question_ar' | translate }}</label>
    <input
      type="text"
      class="form-control"
      placeholder="{{ 'MENU.DASHBOARD.question_ar' | translate }}"
      [(ngModel)]="product.question_ar"
      name="question_ar"
      required
    />
  </div>
</div>

<div class="col-sm-6">
  <div class="mb-3">
    <label class="form-label">{{ 'MENU.DASHBOARD.question_en' | translate }}</label>
    <input
      type="text"
      class="form-control"
      placeholder="{{ 'MENU.DASHBOARD.question_en' | translate }}"
      [(ngModel)]="product.question_en"
      name="question_en"
      required
    />
  </div>
</div>


   <div class="col-sm-6">
  <div class="mb-3">
    <label class="form-label">{{ 'MENU.DASHBOARD.answer_ar' | translate }}</label>
    <input
      type="text"
      class="form-control"
      placeholder="{{ 'MENU.DASHBOARD.answer_ar' | translate }}"
      [(ngModel)]="product.answer_ar"
      name="answer_ar"
      required
    />
  </div>
</div>

<div class="col-sm-6">
  <div class="mb-3">
    <label class="form-label">{{ 'MENU.DASHBOARD.answer_en' | translate }}</label>
    <input
      type="text"
      class="form-control"
      placeholder="{{ 'MENU.DASHBOARD.answer_en' | translate }}"
      [(ngModel)]="product.answer_en"
      name="answer_en"
      required
    />
  </div>
</div>
</div>



     
      <!-- Submit Button -->
      <div class="text-start mt-3">
        <button type="submit" class="btn btn-primary px-4">
           {{ 'MENU.DASHBOARD.save_changes' | translate }}
        </button>
      </div>
    </form>
  </div>
</div>
